<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">“They want you dead, or in their lie. <br/>There’s only one thing a man can do. <br/>Find something that’s his, <br/>and make an island for himself.” <br/>—Sergeant Welsh in Terrence Malick’s film <em class="italic">The Red Line</em> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// thepenaltyarea_00000.vue?27b1b27d